import React from "react"

const InfoDetail = (props) => {
	return <i className="fa-duotone fa-circle-info cursor-help text-xs ml-1" title={props.text}></i>
}

export default InfoDetail
